import { render, staticRenderFns } from "./AnchorPointInputs.vue?vue&type=template&id=c8e9ec0a&scoped=true&"
import script from "./AnchorPointInputs.vue?vue&type=script&lang=js&"
export * from "./AnchorPointInputs.vue?vue&type=script&lang=js&"
import style0 from "./AnchorPointInputs.vue?vue&type=style&index=0&id=c8e9ec0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e9ec0a",
  null
  
)

export default component.exports